import { validators } from '@blazar/tracking'
import gtm from '@blazar/tracking-google-tagmanager'

import * as sendmailActions from 'external/reduxBits/sendmail/actions'

import { renderDataLayerObject } from 'tracking/dataLayerUtils'

const createDataLayerObject = (state, localData = {}) =>
  renderDataLayerObject({
    // No globals needed
    ...{
      event: 'event',
      eventType: 'Engagement',
      objectType: 'UIElement',
    },
    ...localData,
  })

export const adReplyClicked = {
  validators: [validators.redux(sendmailActions.OPENED_AD_REPLY)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectId: 'contact_link',
        objectName: 'Ad reply clicked',
        intent: 'Create',
        objectIsFirstMessage: 'true',
        objectIsWebFormMessage: 'true',
        eventCategory: 'lead',
        eventAction: 'started message',
      }),
    ),
  ],
}

export const createMessage = {
  validators: [validators.redux(sendmailActions.RECEIVE_SENDMAIL, ({ error }) => !error)],
  events: [
    gtm.event(({ state }) =>
      createDataLayerObject(state, {
        objectName: 'Ad reply sent',
        objectType: 'Message',
        eventType: 'Create',
        intent: 'Send',
        eventCategory: 'lead',
        eventAction: 'sent message',
      }),
    ),
  ],
}
